import { Collection } from 'backbone';

class PriceReveal extends Collection {
	get url() {
		return 'nrl/preseason.json';
	}
}

export default PriceReveal;